import React                                                                from 'react';
import PropTypes                                                            from 'prop-types';
import InterviewTileTextBadgesList, {InterviewTileTextBadgesListConfigType} from './InterviewTileTextBadgesList';
import Badges                                                               from './../Base/Badges/Badges';
import BadgesColumn                                                         from './../Base/Badges/BadgesColumn';
import {ModelInterviewType}                                                 from './InterviewTilePropTypes';
import {TileDisplayConfigType}                                              from '../../Grid2';

const InterviewTileBadges = props => {
	const data   = props.data;
	const config = props.config;

	return (
		<Badges displayConfig={props.displayConfig}>
			<BadgesColumn grow={true} shrink={true}>
				<InterviewTileTextBadgesList data={data} config={config.textBadges} />
			</BadgesColumn>
		</Badges>
	);
};

export const InterviewTileBadgesConfigType = PropTypes.shape({
	textBadges: InterviewTileTextBadgesListConfigType,
});

InterviewTileBadges.propTypes = {
	data:          ModelInterviewType.isRequired, // VXQL ModelInterview type
	displayConfig: TileDisplayConfigType.isRequired,
	config:        InterviewTileBadgesConfigType,
};

InterviewTileBadges.defaultProps = {
	config: InterviewTileTextBadgesList.defaultProps.config,
};

export default InterviewTileBadges;
